import * as types from './types'

export default {
  [types.SET_ACCOUNT]: ({ commit, state }, {cookies, users}) => {
    if (state.$account && state.$account.id) {
      return users.getById(state.$account.id).then(user => {
        commit(types.SET_ACCOUNT, {value: user, cookies})
      })
    } else {
      return Promise.reject(new Error('not-logged-in'))
    }
  }
}
